import React, { useState } from "react";
import { CardContent } from "@material-ui/core";
import Swal from "sweetalert2";

import "./cardcompra.css";

import { domain } from "../../../Urls/Services/Api_urls";

import { DashboardSpeed, ModernTv, Wifi, Cart, Phone, DataTransferBoth } from "iconoir-react";
import { calling } from "../FuntionCall/calling";

function Cardcompra(props) {
  const precio = props.precio_persona;
  const descuento = props.descuento_valor[props.estrato];
  const color = props.color;
  const font = props.font;
  const personaLabel = props.personaLabel;

  
  // console.log(estratovista);
  
  /**
   * The function `megasadicionales` returns a JSX element containing a heading with a dynamic number
   * of additional megabytes.
   * @param e - The parameter `e` represents a number that is being passed to the `megasadicionales`
   * function.
   * @returns The code is returning JSX elements wrapped in an h2 tag. The returned JSX elements
   * include a b tag with the value of e + parseInt(props.velocidad) followed by the text "Megas" and a
   * DataTransferBoth component. There is also an h6 tag with the value of Math.trunc(props.velocidad)
   * followed by the text "Megas".
   */
  const megasadicionales = (e) => {
    if (e => 0) {
      return (
        <h2 style={{ fontSize: "30px" }}>
          {/* <h6 style={{ marginBottom: "0.6rem" }}>
            <b>Recibes</b>
          </h6> */}


          <b
            style={{
              color: "#4a1272",
              display: "inline-flex",
              justifyContent: "center",
            }}
          >
            {" "}
            {e + parseInt(props.velocidad)} Megas
            <DataTransferBoth style={{ width: "10%" }} />
          </b>

          <div style={{ marginBottom: "-0.9rem" }}></div>
          {props.discount_months && props.discount_months !== props.months ? (
            <div style={{ marginBottom: "-0.9rem", marginTop: "-1.5rem" }}>
              <b style={{ fontSize: "12px", color: "#4a1272" }}>x{props.discount_months} meses</b>
            </div>
          ) : (
            <div style={{ marginBottom: "-0.9rem", marginTop: "-1.5rem", opacity: 0 }} aria-hidden="true">
              <b style={{ fontSize: "12px" }}>&nbsp;</b>
            </div>
          )}
          <div style={{ display: "inline-flex", marginTop: "-2rem" }}>
            {/* <h6 style={{ paddingRight: "0.5rem" }}>
              <b>Pagas</b>
            </h6> */}
            <h6 className="presnorm"> {Math.trunc(props.velocidad)} Megas</h6>
          </div>

          {/* <h3 style={{ fontSize: "15px" }}>Megas Simétricas</h3> */}
        </h2>
      );
      // <div>
      //   <h2 style={{fontSize: "70px"}}><b>{props.velocidad}</b></h2><h3 style={{fontSize: "25px"}}>Megas Simétricas</h3>
      //  </div>
    }
  };

  /**
   * The function `fun` calls a function `props.funcion` and passes `props` as an argument.
   */
  const fun = () => {
    props.funcion(props);
  };

  /**
   * The function `icons_change` takes a parameter `tipoplan` and returns a JSX element based on the
   * value of `tipoplan`.
   * @param tipoplan - The parameter "tipoplan" is a string that represents the type of plan. It can
   * have the following values: "Triple", "Dupla", "Doble", or "Internet".
   * @returns The function `icons_change` returns JSX elements based on the value of the `tipoplan`
   * parameter.
   */
  const icons_change = (tipoplan) => {
    if (tipoplan === "Triple") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Phone
                className="telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <ModernTv
                className="television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div classname="canales-hd" style={{ display: "none" }}>
              48 Canales
            </div>
            <div classname="canales-sd" style={{ display: "none" }}>
              65 Canales
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Dupla") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>

          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Phone
                className="telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b >Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida" >{props.velocidad} Megas</div>
          </div>
        </>
      );
    } else if (tipoplan === "Doble") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Phone
                className="Telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <ModernTv
                className="television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div classname="canales-hd" style={{ display: "none" }}>
              48 Canales
            </div>
            <div classname="canales-sd" style={{ display: "none" }}>
              65 Canales
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Internet") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
        </>
      );
    }
  };

  return (
    <div className="card" style={{ backgroundColor: color }}>
      <div className="caracteristica-adicional">
        <div
          className="plan"
          dane="76001,76520,76892,76130,76364"
          operador="EMCALI"
          nit="8903990034"
          operador-logo="https://c748596267.imgdist.com/pub/bfra/zs95jvh4/uy4/tyz/u0a/logo_emcali.png"
          url-comercial="https://portalservicios.emcali.net.co/planes"
          valor-numerico={parseInt(precio[props.estrato] || precio.valor)}
          estrato="1,2,3,4,5,6"
          valor={precio[props.estrato] || precio.valor}
          titulo={props.nombreplan}
          duracion="48 semanas"
          style={{ display: "none" }}
        ></div>
        <h6 className="price-label mt-3">{personaLabel || "Plan residencial"}</h6>
      </div>
      <div duracion="48 semanas"></div>
      {/* <div className="nombre_plan1">
        <Typography className={props.nombreplan}>{props.nombreplan}</Typography>
      </div> 
      
      <h4>{props.nombreplan}</h4>
        <div className="price-label">{personaLabel || "Plan residencial"}</div>
        <div className="price-persona">{precio?.[String(props.estrato)] || "—"}</div>
      
      */}

      <CardContent key={props.id}>
        <div>
          {megasadicionales(parseInt(props.megas))}
          {/* <h2 style={{fontSize: "70px"}}><b>{props.velocidad}</b></h2><h3 style={{fontSize: "25px"}}>Megas Simétricas</h3> */}
        </div>

        {/* <div>
          <img className="tar-img" src={image2} alt="Imagen Win Sports" />
        </div> */}

        {/* <hr></hr> */}
        <div className="desdiv">
          <h3 style={{ fontSize: "22px" }}>
          {/* <h6>Estrato {props.estratoview}</h6> */}
            <b>
              {new Intl.NumberFormat("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
              }).format(Math.trunc(descuento[props.estrato] || descuento))}
            </b>{" "}
            
            <b style={{ fontSize: "12px" }}>x{props.months} meses</b>
       
            <div
              className="valor card-title pricing-card-title"
              valor-numerico={parseInt(precio[props.estrato] || precio.valor)}
              estrato="1,2,3,4,5,6"
            >
              <h5 className="presnorm">
                {new Intl.NumberFormat("es-CO", {
                  style: "currency",
                  currency: "COP",
                  minimumFractionDigits: 0,
                }).format(Math.trunc(precio[props.estrato] || precio.valor))}
              </h5>
              <h6 style={{fontSize:"10px"}}>Sujeto a verificacion</h6>
            </div>
          </h3>
        </div>
        <div className="desdiv1"></div>

        <div className="desc">
          <h3 style={{ fontSize: "13px", marginBottom: "0" }}>
            <b>{props.descuento}% dto&nbsp;online</b>
          </h3>
        </div>

        {/* <hr></hr> */}
        <div className="row">{icons_change(props.tipoplan)}</div>
        {/* <div>
          <b>Persona juridica:</b><br></br>
          <h5>
            ${props.precio_empresa}
            <h6>x1 mes</h6>
          </h5>
        </div> */}
        {/* <hr></hr> */}
        <div className="row px-3">
          <button className="action-button buy-button" 
          onClick={() => fun()}>
            <Cart className="icon" style={{}} />
              <b>{props.nombreButton}</b>
          </button>
        </div>
        <div className="row px-3 mt-2" style={{ display: props.display }}>
          <button
            className="action-button phone-button"
            onClick={() => {
              calling(props.nombreplan);
            }}
          >
            <Phone className="icon" style={{}} />
            <h6 className="m-0">
              <b>Te asesoramos</b>
            </h6>
          </button>
        </div>
      </CardContent>
    </div>
  );
}

export default Cardcompra;

